import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {CityService} from '@services/city.service';

@Component({
  selector: 'app-price-city-evol',
  templateUrl: './price-city-evol.component.html',
  styleUrls: ['./price-city-evol.component.scss']
})
export class PriceCityEvolComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor(public cityService: CityService) {
    }

    ngOnInit() {
    }

    toFloat(s) {
        return parseFloat(s);
    }
}
